var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"size":"md","title":_vm.trans('general.page.space_forms.messages.share_form_by_link')},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('share-form-by-link',{on:{"success":_vm.handleSuccess},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }